// @ts-nocheck
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getBillTo, getBillTos } from "@insite/client-framework/Services/CustomersService";
import {
    chain,
    FindDefaultBillTo,
} from "@insite/client-framework/Store/Pages/AccountSettings/Handlers/SetInitialValues";
import { BillToModel } from "@insite/client-framework/Types/ApiModels";
import isEmpty from "lodash/isEmpty";

replaceInChain(chain, FindDefaultBillTo, async props => {
    /* Store Custom Code - Currently this api call is throwing a 404 when a user has a default bill to on another site so we're returning undefined if that happens */
    let defaultBillTo: BillToModel | undefined;
    try {
        defaultBillTo = await getBillTo({ billToId: "default" });
    } catch (error) {
        if (error.status === 404) {
            defaultBillTo = undefined;
        } else {
            throw error;
        }
    }

    if (!isEmpty(defaultBillTo)) {
        props.defaultBillTo = defaultBillTo;
    } else {
        const billToCollection = await getBillTos({
            page: 1,
            pageSize: 1,
        });
        const billTos = billToCollection.billTos!;
        if (billToCollection.pagination?.totalItemCount === 1 && billTos.length === 1) {
            props.defaultBillTo = billTos[0];
        }
    }
});
